(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-feature-blogs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
 const sections = document.querySelectorAll('.c-feature-blogs-container');
 
 sections.forEach(section => {
   const categoryTabs = section.querySelectorAll('.c-feature-blogs__category-tab');
   const splideContainers = section.querySelectorAll('.c-feature-blogs__grid');
   const splideInstances = new Map();

   // 各スライダーを初期化
   splideContainers.forEach(container => {
     const tag = container.getAttribute('data-tag');
     const splideInstance = new Splide(container, {
       perPage: 3,
       perMove: 1,
       gap: 20,
       pagination: false,
       arrows: true,
       speed: 400,
       easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
       trimSpace: false,
       waitForTransition: true,
       breakpoints: {
         699: {
           perPage: 1,
           gap: 18
         }
       }
     }).mount();

     splideInstances.set(tag, splideInstance);
   });

   // 矢印の表示/非表示を制御する関数
   function updateArrowsVisibility(container) {
     const itemCount = container.querySelectorAll('.splide__slide').length;
     const arrows = container.querySelectorAll('.splide__arrow');
     const shouldShow = window.innerWidth <= 699 ? itemCount > 1 : itemCount > 3;
     
     arrows.forEach(arrow => {
       arrow.style.opacity = shouldShow ? '1' : '0';
       arrow.style.visibility = shouldShow ? 'visible' : 'hidden';
     });
   }

   // タブ切り替え時の処理
   function switchTab(selectedTag) {
     splideContainers.forEach(container => {
       container.style.display = 'none';
     });

     const selectedContainer = section.querySelector(`.c-feature-blogs__grid[data-tag="${selectedTag}"]`);
     if (selectedContainer) {
       selectedContainer.style.display = 'block';
       const splideInstance = splideInstances.get(selectedTag);
       if (splideInstance) {
         setTimeout(() => {
           splideInstance.refresh();
           updateArrowsVisibility(selectedContainer);
         }, 0);
       }
     }
   }

   // タブクリックイベントの設定
   categoryTabs.forEach(tab => {
     tab.addEventListener('click', function(event) {
       event.preventDefault();
       
       if (this.classList.contains('active')) {
         return;
       }

       const selectedTag = this.getAttribute('data-tag');
       
       // タブのアクティブ状態を更新
       categoryTabs.forEach(t => t.classList.remove('active'));
       this.classList.add('active');

       // タブコンテンツを切り替え
       switchTab(selectedTag);
     });
   });

   // 初期表示時の処理
   const allTab = section.querySelector('.c-feature-blogs__category-tab[data-tag="all"]');
   if (allTab) {
     allTab.click();
   }

   // リサイズ処理
   let resizeTimer;
   window.addEventListener('resize', () => {
     clearTimeout(resizeTimer);
     resizeTimer = setTimeout(() => {
       const activeTab = section.querySelector('.c-feature-blogs__category-tab.active');
       const selectedTag = activeTab ? activeTab.getAttribute('data-tag') : 'all';
       const selectedContainer = section.querySelector(`.c-feature-blogs__grid[data-tag="${selectedTag}"]`);
       if (selectedContainer) {
         updateArrowsVisibility(selectedContainer);
       }
     }, 200);
   });
 });
});

  } catch(e) { console.error(e); }
})();
})();
